import { styled } from '@mui/material/styles';
import { Box, Paper, Stack } from '@mui/material';

export const BackgroundBox = styled(Box)({
  backgroundImage: 'url("/to_vrts.webp")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledPaper = styled(Paper)<{ cardHeight?: string }>(({ cardHeight }) => ({
  width: '15%',
  minWidth: '300px',
  height: cardHeight ?? '40vh',
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  alignItems: 'center',
}));

export const ContentStack = styled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '80%',
  justifyContent: 'center',
});

export const CenteredBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}); 